import { type FC } from "react";
import { useDrag } from "react-dnd";
import { type GridDragHandleItemType, type GridDragItemFactory, type GridDragItemType } from "../GridDropLayer";

export const enum GridCursorDirection {
    TOP = 0b0001,
    LEFT = 0b0010,
    RIGHT = 0b0100,
    BOTTOM = 0b1000,
}

export const GRID_CURSOR_HANDLE_TYPE = "grid-cursor-handle";
export const GRID_CURSOR_MOVE_TYPE = "grid-cursor-move";

interface Props {
    direction: number;
    onEnd: (item: GridDragItemType) => void;
    createItem: GridDragItemFactory;
    className?: string;
    valid: boolean;
    deleting: boolean;
}

export const GridCursorHandle: FC<Props> = ({
    direction,
    createItem,
    className,
    onEnd,
    valid,
    deleting,
}) => {
    const [ , drag ] = useDrag(() => ({
        type: GRID_CURSOR_HANDLE_TYPE,
        item: monitor => ({
            ...createItem(monitor),
            direction,
        }) as GridDragHandleItemType,
        end: onEnd,
    }), [ createItem, onEnd ]);

    const classes = [ "grid-cursor w-4 h-4 rounded-full absolute" ];

    if(className) {
        classes.push(className);
    }

    if(valid && !deleting) {
        classes.push("bg-blue-500");
    } else {
        classes.push("bg-red-500");
    }

    if(
        direction & GridCursorDirection.TOP && direction & GridCursorDirection.LEFT ||
        direction & GridCursorDirection.BOTTOM && direction & GridCursorDirection.RIGHT
    ) {
        classes.push("cursor-nwse-resize");
    } else if(
        direction & GridCursorDirection.TOP && direction & GridCursorDirection.RIGHT ||
        direction & GridCursorDirection.BOTTOM && direction & GridCursorDirection.LEFT
    ) {
        classes.push("cursor-nesw-resize");
    } else if(
        direction & GridCursorDirection.TOP ||
        direction & GridCursorDirection.BOTTOM
    ) {
        classes.push("cursor-ns-resize");
    } else if(
        direction & GridCursorDirection.RIGHT ||
        direction & GridCursorDirection.LEFT
    ) {
        classes.push("cursor-ew-resize");
    }

    return (
        <div
            ref={el => {
                drag(el);
            }}
            className={classes.join(" ")}
        />
    );
};
